var chunkToChildrenMap = {
	"535": [
		1185
	],
	"1294": [
		8849,
		7343,
		2919,
		9335,
		2874,
		4261,
		5894,
		1201,
		2695,
		5839
	],
	"7552": [
		8849,
		7343,
		2919,
		9335,
		2874,
		4261,
		5894,
		1201,
		2695,
		5839
	],
	"8117": [
		8849,
		7343,
		9175,
		4219,
		6834
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));